import React from 'react';
import { ChevronRight, Users } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { Topic } from '../data/topics';
export const TOPIC_IMAGES: Record<string, string> = {
  'ai-governance': 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80',
  'climate-adaptation': 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800&q=80',
  'food-security': 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80',
  biodiversity: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&q=80',
  'innovative-finance': 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=800&q=80',
  'twin-transition': 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&q=80',
  'frontier-tech': 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80',
  regenerative: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800&q=80',
  partnerships: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=80',
  'skills-mobility': 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&q=80'
};
interface Props {
  topic: Topic;
  onSelect: (topicId: string) => void;
}
export function TopicImageCard({
  topic,
  onSelect
}: Props) {
  const {
    t
  } = useLanguage();
  const countLabel = t('discover.interestedCount').replace('{n}', String(topic.interestedCount));
  const imageUrl = TOPIC_IMAGES[topic.id] || 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80';
  return <button onClick={() => onSelect(topic.id)} className="relative w-full h-[200px] overflow-hidden active:scale-[0.98] transition-transform text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C5D82D] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0D0D0D] block" data-id="element-397">
      {/* Background Image */}
      <img src={imageUrl} alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-398" />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 30%, #0D0D0D 100%)'
    }} data-id="element-399" />

      {/* Content */}
      <div className="absolute inset-0 p-4 flex flex-col justify-between pb-[22px]" data-id="element-400">
        {/* Top: Badge */}
        <div className="flex justify-start" data-id="element-401">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-2xl bg-black/40 backdrop-blur-md border border-white/10 text-white/90 text-[11px] font-medium" data-id="element-402">
            <Users className="w-3.5 h-3.5" data-id="element-403" />
            {countLabel}
          </div>
        </div>

        {/* Bottom: Text & Icon */}
        <div className="flex items-end justify-between gap-4" data-id="element-404">
          <div className="flex-1 min-w-0" data-id="element-405">
            <h3 className="text-white drop-shadow-sm text-[20px] font-[500]" data-id="element-406">
              {t(topic.nameKey)}
            </h3>
          </div>
          <div className="w-8 h-8 rounded-2xl bg-white/10 backdrop-blur-md flex items-center justify-center shrink-0" data-id="element-407">
            <ChevronRight className="w-5 h-5 text-white" data-id="element-408" />
          </div>
        </div>
      </div>
    </button>;
}